export const t = {
  en: {
    nav_services: "Services",
    nav_pricing: "Pricing",
    nav_gallery: "Our Work",
    nav_area: "Service Area",
    nav_quote: "Get Quote",
    nav_admin: "Office Login",
    call: "Call",
    call_now: "Call Now",
    whatsapp: "WhatsApp",
    get_quote: "Get Quote",
    upload_quote: "Upload & Quote",

    hero_badge: "Vidyaranyapura, Bengaluru · Est. Local Print Workshop",
    hero_title: "High-Impact Flex, Vinyl & LED Signage Printing in Bengaluru",
    hero_sub: "Direct from our Vidyaranyapura workshop — same-day flex banners, premium backlit vinyl, 3D acrylic LED letters and sunboard displays. Trusted by local shops, events and offices.",
    hero_cta_call: "Call +91 63630 32874",
    hero_cta_wa: "WhatsApp Artwork",
    hero_cta_quote: "Upload Design & Get Quote",
    hero_stat_1: "Same-Day Flex Printing",
    hero_stat_2: "2-Year LED Warranty",
    hero_stat_3: "Free Bengaluru Delivery",

    services_kicker: "What We Print",
    services_title: "Priority Services",
    services_sub: "Four core services we do best. Fixed rates where possible, custom quotes where your job needs it.",

    pricing_kicker: "Transparent Rates",
    pricing_title: "Pricing",
    pricing_fixed: "Fixed Price Products",
    pricing_fixed_sub: "Ready rates — order straight away.",
    pricing_custom: "Custom Quote Jobs",
    pricing_custom_sub: "Priced on size, material & finish. Get a fast quote.",
    starting_from: "Starting from",
    turnaround: "Turnaround",
    get_this_quote: "Get Quote",

    area_kicker: "Where We Deliver",
    area_title: "Bengaluru Service Area",
    area_sub: "Workshop in Vidyaranyapura with doorstep delivery and on-site installation across North Bengaluru.",
    visit_us: "Visit Our Workshop",

    gallery_kicker: "Real Work",
    gallery_title: "Recent Jobs Around Bengaluru",

    quote_kicker: "Fast Response",
    quote_title: "Request a Quote",
    quote_sub: "Fill this in and our office team replies during business hours. Prefer to talk? Call or WhatsApp us.",
    f_name: "Full Name",
    f_phone: "Phone / WhatsApp Number",
    f_service: "Service Needed",
    f_dimensions: "Dimensions (e.g. 6ft x 3ft)",
    f_quantity: "Quantity",
    f_install: "Need installation in Bengaluru?",
    f_delivery: "Target Delivery Date",
    f_message: "Details / Message",
    f_artwork: "Upload Artwork (PDF, AI, PSD, CDR, PNG, JPG)",
    f_artwork_hint: "Any file type accepted. You can add multiple files.",
    f_submit: "Send Enquiry",
    f_submitting: "Sending…",
    f_choose: "Choose a service",
    f_yes: "Yes",
    f_no: "No",
    f_upload_btn: "Choose files",
    f_uploading: "Uploading…",
    quote_success: "Thank you! Your enquiry is received. Our team will contact you shortly.",
    quote_error: "Something went wrong. Please call or WhatsApp us.",
    f_required: "Please fill name, phone and service.",

    footer_hours: "Business Hours",
    footer_contact: "Contact",
    footer_services: "Services",
    footer_rights: "All rights reserved.",
    footer_note: "Lead-first · WhatsApp · Call · Quote",

    admin_title: "Office Login",
    admin_sub: "Creative Prints — Lead Dashboard",
    admin_email: "Email",
    admin_password: "Password",
    admin_login: "Log In",
    admin_logout: "Log Out",
    admin_invalid: "Invalid email or password",
  },
  kn: {
    nav_services: "ಸೇವೆಗಳು",
    nav_pricing: "ಬೆಲೆ",
    nav_gallery: "ನಮ್ಮ ಕೆಲಸ",
    nav_area: "ಸೇವಾ ಪ್ರದೇಶ",
    nav_quote: "ಕೋಟ್ ಪಡೆಯಿರಿ",
    nav_admin: "ಆಫೀಸ್ ಲಾಗಿನ್",
    call: "ಕರೆ",
    call_now: "ಈಗ ಕರೆ ಮಾಡಿ",
    whatsapp: "ವಾಟ್ಸಾಪ್",
    get_quote: "ಕೋಟ್ ಪಡೆಯಿರಿ",
    upload_quote: "ಅಪ್‌ಲೋಡ್ & ಕೋಟ್",

    hero_badge: "ವಿದ್ಯಾರಣ್ಯಪುರ, ಬೆಂಗಳೂರು · ಸ್ಥಳೀಯ ಪ್ರಿಂಟ್ ವರ್ಕ್‌ಶಾಪ್",
    hero_title: "ಬೆಂಗಳೂರಿನಲ್ಲಿ ಉನ್ನತ ಗುಣಮಟ್ಟದ ಫ್ಲೆಕ್ಸ್, ವಿನೈಲ್ ಮತ್ತು LED ಸೈನ್ ಬೋರ್ಡ್ ಪ್ರಿಂಟಿಂಗ್",
    hero_sub: "ವಿದ್ಯಾರಣ್ಯಪುರ ವರ್ಕ್‌ಶಾಪ್‌ನಿಂದ ನೇರವಾಗಿ — ಅದೇ ದಿನ ಫ್ಲೆಕ್ಸ್ ಬ್ಯಾನರ್, ಬ್ಯಾಕ್‌ಲಿಟ್ ವಿನೈಲ್, 3D ಅಕ್ರಿಲಿಕ್ LED ಅಕ್ಷರಗಳು ಮತ್ತು ಸನ್‌ಬೋರ್ಡ್ ಡಿಸ್‌ಪ್ಲೇಗಳು.",
    hero_cta_call: "ಕರೆ +91 63630 32874",
    hero_cta_wa: "ವಾಟ್ಸಾಪ್ ಆರ್ಟ್‌ವರ್ಕ್",
    hero_cta_quote: "ಡಿಸೈನ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ ಕೋಟ್ ಪಡೆಯಿರಿ",
    hero_stat_1: "ಅದೇ ದಿನ ಫ್ಲೆಕ್ಸ್ ಪ್ರಿಂಟಿಂಗ್",
    hero_stat_2: "2 ವರ್ಷ LED ವಾರಂಟಿ",
    hero_stat_3: "ಉಚಿತ ಬೆಂಗಳೂರು ಡೆಲಿವರಿ",

    services_kicker: "ನಾವು ಏನು ಪ್ರಿಂಟ್ ಮಾಡುತ್ತೇವೆ",
    services_title: "ಪ್ರಮುಖ ಸೇವೆಗಳು",
    services_sub: "ನಾವು ಅತ್ಯುತ್ತಮವಾಗಿ ಮಾಡುವ ನಾಲ್ಕು ಸೇವೆಗಳು. ನಿಗದಿತ ಬೆಲೆ ಅಥವಾ ಕಸ್ಟಮ್ ಕೋಟ್.",

    pricing_kicker: "ಪಾರದರ್ಶಕ ದರಗಳು",
    pricing_title: "ಬೆಲೆ",
    pricing_fixed: "ನಿಗದಿತ ಬೆಲೆ ಉತ್ಪನ್ನಗಳು",
    pricing_fixed_sub: "ಸಿದ್ಧ ದರಗಳು — ನೇರವಾಗಿ ಆರ್ಡರ್ ಮಾಡಿ.",
    pricing_custom: "ಕಸ್ಟಮ್ ಕೋಟ್ ಕೆಲಸಗಳು",
    pricing_custom_sub: "ಗಾತ್ರ, ವಸ್ತು ಮತ್ತು ಫಿನಿಶ್ ಆಧಾರಿತ ಬೆಲೆ.",
    starting_from: "ಪ್ರಾರಂಭ",
    turnaround: "ಸಮಯ",
    get_this_quote: "ಕೋಟ್ ಪಡೆಯಿರಿ",

    area_kicker: "ನಾವು ಎಲ್ಲಿ ಡೆಲಿವರ್ ಮಾಡುತ್ತೇವೆ",
    area_title: "ಬೆಂಗಳೂರು ಸೇವಾ ಪ್ರದೇಶ",
    area_sub: "ವಿದ್ಯಾರಣ್ಯಪುರದಲ್ಲಿ ವರ್ಕ್‌ಶಾಪ್, ಉತ್ತರ ಬೆಂಗಳೂರಿನಾದ್ಯಂತ ಡೆಲಿವರಿ ಮತ್ತು ಇನ್‌ಸ್ಟಾಲೇಶನ್.",
    visit_us: "ನಮ್ಮ ವರ್ಕ್‌ಶಾಪ್‌ಗೆ ಭೇಟಿ ನೀಡಿ",

    gallery_kicker: "ನಿಜವಾದ ಕೆಲಸ",
    gallery_title: "ಬೆಂಗಳೂರಿನಲ್ಲಿ ಇತ್ತೀಚಿನ ಕೆಲಸಗಳು",

    quote_kicker: "ವೇಗದ ಪ್ರತಿಕ್ರಿಯೆ",
    quote_title: "ಕೋಟ್ ವಿನಂತಿಸಿ",
    quote_sub: "ಇದನ್ನು ಭರ್ತಿ ಮಾಡಿ, ನಮ್ಮ ತಂಡ ವ್ಯವಹಾರ ಸಮಯದಲ್ಲಿ ಉತ್ತರಿಸುತ್ತದೆ.",
    f_name: "ಪೂರ್ಣ ಹೆಸರು",
    f_phone: "ಫೋನ್ / ವಾಟ್ಸಾಪ್ ಸಂಖ್ಯೆ",
    f_service: "ಬೇಕಾದ ಸೇವೆ",
    f_dimensions: "ಅಳತೆಗಳು (ಉದಾ. 6ft x 3ft)",
    f_quantity: "ಪ್ರಮಾಣ",
    f_install: "ಬೆಂಗಳೂರಿನಲ್ಲಿ ಇನ್‌ಸ್ಟಾಲೇಶನ್ ಬೇಕೇ?",
    f_delivery: "ಗುರಿ ಡೆಲಿವರಿ ದಿನಾಂಕ",
    f_message: "ವಿವರಗಳು / ಸಂದೇಶ",
    f_artwork: "ಆರ್ಟ್‌ವರ್ಕ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ (PDF, AI, PSD, CDR, PNG, JPG)",
    f_artwork_hint: "ಯಾವುದೇ ಫೈಲ್ ಪ್ರಕಾರ ಸ್ವೀಕಾರ. ಹಲವು ಫೈಲ್‌ಗಳನ್ನು ಸೇರಿಸಬಹುದು.",
    f_submit: "ವಿಚಾರಣೆ ಕಳುಹಿಸಿ",
    f_submitting: "ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ…",
    f_choose: "ಸೇವೆ ಆಯ್ಕೆಮಾಡಿ",
    f_yes: "ಹೌದು",
    f_no: "ಇಲ್ಲ",
    f_upload_btn: "ಫೈಲ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    f_uploading: "ಅಪ್‌ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
    quote_success: "ಧನ್ಯವಾದಗಳು! ನಿಮ್ಮ ವಿಚಾರಣೆ ಸ್ವೀಕರಿಸಲಾಗಿದೆ. ನಮ್ಮ ತಂಡ ಶೀಘ್ರದಲ್ಲೇ ಸಂಪರ್ಕಿಸುತ್ತದೆ.",
    quote_error: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ದಯವಿಟ್ಟು ಕರೆ ಅಥವಾ ವಾಟ್ಸಾಪ್ ಮಾಡಿ.",
    f_required: "ದಯವಿಟ್ಟು ಹೆಸರು, ಫೋನ್ ಮತ್ತು ಸೇವೆ ಭರ್ತಿ ಮಾಡಿ.",

    footer_hours: "ವ್ಯವಹಾರ ಸಮಯ",
    footer_contact: "ಸಂಪರ್ಕ",
    footer_services: "ಸೇವೆಗಳು",
    footer_rights: "ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    footer_note: "ಲೀಡ್-ಫಸ್ಟ್ · ವಾಟ್ಸಾಪ್ · ಕರೆ · ಕೋಟ್",

    admin_title: "ಆಫೀಸ್ ಲಾಗಿನ್",
    admin_sub: "ಕ್ರಿಯೇಟಿವ್ ಪ್ರಿಂಟ್ಸ್ — ಲೀಡ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    admin_email: "ಇಮೇಲ್",
    admin_password: "ಪಾಸ್‌ವರ್ಡ್",
    admin_login: "ಲಾಗಿನ್",
    admin_logout: "ಲಾಗ್ ಔಟ್",
    admin_invalid: "ತಪ್ಪಾದ ಇಮೇಲ್ ಅಥವಾ ಪಾಸ್‌ವರ್ಡ್",
  },
};
